import { getEmojiByName } from "@/assets/emojis";
import { cn } from "@/lib/utils";
import React from "react";
import { NavLink } from "react-router-dom";

interface CustomViewItemProps {
    label: string | React.ReactNode;
    icon?: string;
    to: string;
}

const CustomViewItem = ({ label, icon, to }: CustomViewItemProps) => (
    <NavLink
        className={({ isActive }) =>
            cn(
                "flex w-full items-center justify-between gap-2 rounded-md px-1.5 py-2 text-xs hover:bg-surface-activeFg hover:text-accent-foreground",
                isActive && "bg-surface-infoBg",
            )
        }
        to={to}
    >
        <span className="flex items-center gap-1 text-left">
            <span>{icon && getEmojiByName(icon)?.symbol}</span>
            <span className="line-clamp-2">{label}</span>
        </span>
    </NavLink>
);

export default CustomViewItem;
